<template>
  <div>
    <!-- <div class="demo-guide-background"  @click="$emit('close')"></div> -->
    <div
      id="demo-guide"
      :style="{ top: top + 'px', left: left + 'px' }"
      :class="{
        'translate-left': translateLeft,
        'translate-right': translateRight
      }"
    >
      <div class="content">
        <h3>{{ guideType[demoGuideCurrentStep - 1].title }}</h3>
        <p v-html="guideType[demoGuideCurrentStep - 1].text"></p>

        <button class="btn btn-primary btn-xs" @click="$emit('close')">{{$t('demo.post-guide.close')}}</button>
        <button class="btn btn-xs" @click="dismissGuide()">{{$t('demo.post-guide.dismiss')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import demoHelper from "@/assets/js/demoHelper.js";
export default {
  props: {},
  data() {
    return {
      hideContent: true,
      windowHeight: null,
      windowWidth: null,
      // Fits users who signed up with "Shopify"
      shopifySteps: [
        {
          title: this.$t('demo.post-guide.shopify-1.title'),
          text: this.$t('demo.post-guide.shopify-1.text')
        },
        {
          title: this.$t('demo.post-guide.shopify-2.title'),
          text: this.$t('demo.post-guide.shopify-2.text')
        },
        {
          title: this.$t('demo.post-guide.shopify-3.title'),
          text: this.$t('demo.post-guide.shopify-3.text'),
          last: true
        }
      ],
      // Fits users who signed up with "other"
      otherSteps:[
        {
          title: this.$t('demo.post-guide.other-1.title'),
          text: this.$t('demo.post-guide.other-1.text'),
        },
        {
          title: this.$t('demo.post-guide.other-2.title'),
          text: this.$t('demo.post-guide.other-2.text'),
          last: true
        }
      ]
    };
  },

  computed: {
    guideType(){
      return this.$store.state.contentTypes.some(c => c.name == "Shopify" || c.custom == false) ? this.shopifySteps : this.otherSteps
    },
    demoGuideSteps() {
      return this.$store.state.demoGuideSteps;
    },
    demoGuideCurrentStep() {
      return this.$store.state.demoGuideCurrentStep;
    },
    showDemoGuide() {
      return this.$store.state.showDemoGuide;
    },
    guideIsReady() {
      return this.$store.getters.guideIsReady;
    },
    top() {
      return this.$store.state.demoGuideSteps.find((s) => s.step == this.demoGuideCurrentStep).y;
    },
    left() {
      return this.$store.state.demoGuideSteps.find((s) => s.step == this.demoGuideCurrentStep).x;
    },
    topPercentage() {
      return Math.floor((this.top / this.windowHeight) * 100);
    },
    leftPercentage() {
      return Math.floor((this.left / this.windowWidth) * 100);
    },
    translateLeft() {
      return this.$store.state.demoGuideSteps.find((s) => s.step == this.demoGuideCurrentStep).placement == "left";
    },
    translateRight() {
      return this.$store.state.demoGuideSteps.find((s) => s.step == this.demoGuideCurrentStep).placement == "right";
    },
    showingLastStep() {
      return this.guideType[this.demoGuideCurrentStep - 1].last;
    }
  },
  methods: {
    dismissGuide() {
      demoHelper.setDemoGuideEnded(this.$store.state.user.username);
      this.$store.commit("setPostDemoGuide", false);
      this.$store.commit("showDemoGuide", false);
    },
    onOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.$emit("close");
      }
    }
  },
  watch: {
    showingLastStep: {
      handler() {
        if (this.showingLastStep) {
          demoHelper.setDemoGuideEnded(this.$store.state.user.username);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
    setTimeout(() => {
      if (!this.$root.outsideClickHandler) {
        this.$root.outsideClickHandler = (event) => this.$root.$emit("window-click", event);
        window.addEventListener("click", this.$root.outsideClickHandler);
      }
      this.$root.$on("window-click", this.onOutsideClick);
    }, 10);
  },
  beforeDestroy() {
    this.$root.$off("window-click", this.onOutsideClick);
    if (this.showingLastStep) {
      this.dismissGuide();
    }
  }
};
</script>

<style lang="less">
#demo-guide {
  top: 0;
  left: 50%;
  position: absolute;
  z-index: 999;
  max-width: 260px;
  background-color: #fff;
  padding: 12px;
  border-radius: var(--standard-border-radius);
  border: 1px solid var(--orange-web);
  filter: drop-shadow(-1px 0px 4px rgba(0, 0, 0, 0.2));

  &::before {
    content: "";
    top: 0px;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
   
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
  }

  &.translate-left {
    transform: translate(-100%, 50%);
    &::before {
       border-right: 1px solid var(--orange-web);
    border-top: 1px solid var(--orange-web);
      left: calc(100% - 5px);
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &.translate-right {
    transform: translateX(10px);
    &::before {
       border-left: 1px solid var(--orange-web);
    border-bottom: 1px solid var(--orange-web);
      left: 0px;
      top: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  .actions {
    display: flex;
    flex-direction: row;
    gap: 8px;

    button {
      white-space: nowrap;
    }
  }

}
  .demo-guide-background {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.122);
    z-index: 10;
  }
</style>
